import gql from 'graphql-tag'

const archiveFolder = gql`
  mutation archiveFolder($workspace_id: Float!, $folder_id: Float!) {
    archiveFolder(workspace_id: $workspace_id, folder_id: $folder_id) {
      status
      msg
      data
    }
  }
`

export default archiveFolder
